import React from 'react';

function Headline(props) {
    const { title } = props;

    return <h3 style={{ marginBottom: 40 }}>{title}</h3>;
}

export default Headline;
